module.exports = __webpack_public_path__ + "1698f2886a1c568818060b89230b7ec4.svg";